/**
 * @desc 更新POD文件
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.outMaster.updatePodFile.Params, options?: any) {
  return updateResponse(
    http(URL + `/outMaster/updatePodFile`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
